import script from "./PostAudioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PostAudioButton.vue?vue&type=script&setup=true&lang=js"

import "./PostAudioButton.vue?vue&type=style&index=0&id=8d8e0c88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8e0c88"]])

export default __exports__